// extracted by mini-css-extract-plugin
export default {"formInputs":"ReminderFormList_formInputs__6ddbr","remindersForm":"ReminderFormList_remindersForm__mG6MO"};